import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import '../styles/downloads.css';
import { useTranslation } from '../hooks/useTranslation';

const Download = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [selectedPlatform, setSelectedPlatform] = useState('windows');

  const currentLang =
    i18n && typeof i18n.language === 'string' ? i18n.language : 'ru';

  const platformVideos = {
    windows: 'https://diamondvpn.online/uploads/instructionWindows.mp4',
    android: 'https://diamondvpn.online/uploads/instructionAndroid.mp4',
    ios: 'https://diamondvpn.online/uploads/instructionIos.mp4',
  };

  const subtitleText =
    t('download.subtitle') ||
    (currentLang.startsWith('ru')
      ? 'Выберите платформу и скачайте приложение.'
      : 'Choose your platform and download the app.');

  return (
    <div className="downloads-page">
      <SEO
        title={`${t('download.title')} – Diamond VPN`}
        description={subtitleText}
        ogImage="https://diamondvpn.online/preview.jpg"
      />

      <div className="downloads-container" data-aos="fade-up">
        <div className="downloads-header">
          <h1 className="downloads-title">{t('download.title')}</h1>
          <p className="downloads-subtitle">{subtitleText}</p>
        </div>

        <div className="downloads-grid">
          {/* Android */}
          <div className="download-card" data-aos="fade-up" data-aos-delay="50">
            <div className="card-icon android">
              <i className="fab fa-android" aria-hidden="true" />
            </div>
            <div className="card-title">{t('download.android.title')}</div>
            <div className="card-desc">{t('download.android.desc')}</div>
            <a
              className="card-btn"
              href="https://diamondvpn.online/uploads/DiamondVPN.apk"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('download.android.button')}
            </a>
          </div>

          {/* iOS */}
          <div className="download-card" data-aos="fade-up" data-aos-delay="100">
            <div className="card-icon ios">
              <i className="fab fa-apple" aria-hidden="true" />
            </div>
            <div className="card-title">{t('download.ios.title')}</div>
            <div className="card-desc">{t('download.ios.desc')}</div>
            <div className="card-buttons">
              <a
                className="card-btn"
                href="https://apps.apple.com/ru/app/happ-proxy-utility-plus/id6746188973"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('download.ios.buttonRu')}
              </a>
              <a
                className="card-btn"
                href="https://apps.apple.com/us/app/happ-proxy-utility/id6504287215"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('download.ios.buttonGlobal')}
              </a>
            </div>
            <div className="card-note">{t('download.ios.note')}</div>
          </div>

          {/* Windows */}
          <div className="download-card" data-aos="fade-up" data-aos-delay="150">
            <div className="card-icon windows">
              <i className="fab fa-windows" aria-hidden="true" />
            </div>
            <div className="card-title">{t('download.windows.title')}</div>
            <div className="card-desc">{t('download.windows.desc')}</div>
            <a
              className="card-btn"
              href="https://diamondvpn.online/uploads/DiamondVPN.exe"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('download.windows.button')}
            </a>
          </div>
        </div>

        <div className="downloads-howto" data-aos="fade-up" data-aos-delay="200">
          <h2 className="howto-title">{t('download.howTo.title')}</h2>
          <p className="howto-subtitle">{t('download.howTo.platformLabel')}</p>

          <div className="howto-platforms">
            <button
              type="button"
              className={`howto-platform-btn ${
                selectedPlatform === 'windows' ? 'active' : ''
              }`}
              onClick={() => setSelectedPlatform('windows')}
            >
              {t('download.howTo.windows')}
            </button>
            <button
              type="button"
              className={`howto-platform-btn ${
                selectedPlatform === 'android' ? 'active' : ''
              }`}
              onClick={() => setSelectedPlatform('android')}
            >
              {t('download.howTo.android')}
            </button>
            <button
              type="button"
              className={`howto-platform-btn ${
                selectedPlatform === 'ios' ? 'active' : ''
              }`}
              onClick={() => setSelectedPlatform('ios')}
            >
              {t('download.howTo.ios')}
            </button>
          </div>

          <div className="howto-video-wrapper">
            <video
              className="howto-video"
              controls
              src={platformVideos[selectedPlatform]}
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <div className="howto-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => navigate('/manual')}
            >
              {t('download.howTo.otherInstructions')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Download;
